module.exports = __webpack_public_path__ + "static/media/failed.ca09fcc3.svg";